import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './AuthProvider';

interface PageLayoutProps {
  children: React.ReactNode;
}

export function PageLayout({ children }: PageLayoutProps) {
  const { displayName, handleSignOut } = useAuth();

  return (
    <div className="page-layout">
      <header className="dashboard-header" role="banner">
        <h1>AuditMyPay</h1>
        <nav aria-label="Main navigation">
          <Link to="/dashboard" className="nav-link" aria-label="Dashboard">
            Dashboard
          </Link>
          <Link to="/history" className="nav-link" aria-label="Audit history">
            History
          </Link>
          <Link to="/settings" className="nav-link" aria-label="Settings">
            Settings
          </Link>
          <Link to="/account" className="nav-link" aria-label="Account">
            Account
          </Link>
        </nav>
        <nav aria-label="User actions">
          <span className="user-greeting" aria-label="Signed in user">
            {displayName ?? 'User'}
          </span>
          <button
            onClick={handleSignOut}
            className="sign-out-button"
            aria-label="Sign out"
          >
            Sign Out
          </button>
        </nav>
      </header>
      {children}
    </div>
  );
}
